import { call, put, takeLatest, all, takeEvery } from "redux-saga/effects";
import {
  IDEA_SUBMIT_REQUESTING,
  IDEA_SUBMIT_SUCCESS,
  IDEA_SUBMIT_ERROR,
  IDEA_GET_SELECTION_REQUESTING,
  IDEA_GET_SELECTION_SUCCESS,
  IDEA_GET_SELECTION_ERROR,
  IDEA_USER_GET_REQUESTING,
  IDEA_USER_GET_SUCCESS,
  IDEA_USER_GET_ERROR,
  IDEA_USER_DELETE_REQUESTING,
  IDEA_USER_MODIFY_REQUESTING,
  IDEA_USER_MODIFY_SUCCESS,
  IDEA_USER_MODIFY_ERROR,
  IDEA_USER_DELETE_SUCCESS,
  IDEA_USER_DELETE_ERROR,
  IDEA_RATE_REQUESTING,
  IDEA_RATE_ERROR,
  IDEA_RATE_SUCCESS,
  IDEA_GET_ALL_SUCCESS,
  IDEA_GET_ALL_ERROR,
  IDEA_GET_ALL_REQUESTING,
  IDEA_CHANGE_STATUS_REQUESTING,
  IDEA_CHANGE_STATUS_SUCCESS,
  IDEA_CHANGE_STATUS_ERROR,
  IDEA_POST_COMMENT_REQUESTING,
  IDEA_POST_COMMENT_SUCCESS,
  IDEA_POST_COMMENT_ERROR,
  IDEA_LOAD_ALL_REQUESTING,
  IDEA_LOAD_ALL_SUCCESS,
  IDEA_LOAD_ALL_ERROR,
  IDEA_UPLOAD_PICTURE_ERROR,
  IDEA_UPLOAD_PICTURE_SUCCESS,
  IDEA_UPLOAD_PICTURE_REQUESTING,
  IDEA_SELECTED_UPLOAD_PICTURE_REQUESTING,
  IDEA_SELECTED_UPLOAD_PICTURE_SUCCESS,
  IDEA_SELECTED_UPLOAD_PICTURE_ERROR,
  IDEA_GET_REQUESTING,
  IDEA_SEE_SELECT,
  IDEA_GET_ERROR,
} from "./constants";
import { navigate } from "../navigation/navigatorHelper";
import { fetchApi } from "../api";
import { modifyUser } from "../user/actions";
import { showAlert } from "../profileSettings/actions";
import i18n from "../../i18n";

const endPoints = {
  submitIdea: "/v1/ideas/create",
  getIdeasSelection: "/v1/ideas/get-selection",
  getIdea: "/v1/ideas",
  getUserIdeas: "/v1/ideas/get-user-ideas",
  modifyUserIdea: "/v1/ideas/",
  deleteUserIdea: "/v1/ideas/delete",
  rateIdea: "/v1/ideas/rate",
  getAllIdeas: "/v1/ideas/get-all",
  postIdeaComment: "/v1/ideas/comment",
  uploadImage: "/v1/upload/sign-s3?",
  promoteIdea: "/v1/ideas/promote",
};

const uploadImageApi = (data: string) => {
  return fetchApi(
    `${endPoints.uploadImage}file-name=${data.name}&file-type=image/jpg`,
    {},
    "get",
  );
};

const submitIdeaApi = data => {
  return fetchApi(endPoints.submitIdea, data, "post");
};

const getIdeasSelectionApi = data => {
  return fetchApi(endPoints.getIdeasSelection, data, "post");
};

const getUserIdeasApi = data => {
  return fetchApi(endPoints.getUserIdeas, data, "post");
};

const modifyUserIdeaApi = data => {
  return fetchApi(endPoints.modifyUserIdea, data, "put");
};

const promoteIdeaApi = data => {
  return fetchApi(endPoints.promoteIdea, data, "post");
};

const deleteUserIdeaApi = data => {
  return fetchApi(endPoints.deleteUserIdea, data, "post");
};

const rateIdeaApi = data => {
  return fetchApi(endPoints.rateIdea, data, "post");
};

const getAllIdeasApi = data => {
  return fetchApi(endPoints.getAllIdeas, data, "post");
};

const postCommentApi = data => {
  return fetchApi(endPoints.postIdeaComment, data, "post");
};

const getIdeaApi = data => {
  const { ideaId } = data;
  return fetchApi(`${endPoints.getIdea}/${ideaId}`, {}, "get");
};

function* uploadSelectedIdeaPictureFlow(action) {
  try {
    const data = action.payload;

    const resData = yield call(uploadImageApi, data);
    const { signedRequest, url } = resData;
    // const response = yield call(uploadS3, signedRequest, data.uri);

    const { userId, picture } = data;

    yield put({ type: IDEA_SELECTED_UPLOAD_PICTURE_SUCCESS, payload: picture });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_SELECTED_UPLOAD_PICTURE_ERROR, payload: error });
  }
}

function* uploadIdeaPictureFlow(action) {
  try {
    const data = action.payload;

    const resData = yield call(uploadImageApi, data);
    const { signedRequest, url } = resData;
    // const response = yield call(uploadS3, signedRequest, data.uri);

    const { userId, picture } = data;

    yield put({ type: IDEA_UPLOAD_PICTURE_SUCCESS, payload: picture });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_UPLOAD_PICTURE_ERROR, payload: error });
  }
}

function* deleteUserIdeaFlow(action) {
  try {
    const data = action.payload;
    const response = yield call(deleteUserIdeaApi, data);

    yield put({ type: IDEA_USER_DELETE_SUCCESS, payload: response });
    navigate("Innovapulse");
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_USER_DELETE_ERROR, payload: error });
  }
}

function* getUserIdeasFlow(action) {
  try {
    const data = action.payload;
    const response = yield call(getUserIdeasApi, data);

    yield put({ type: IDEA_USER_GET_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_USER_GET_ERROR, payload: error });
  }
}

function* submitIdeaFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(submitIdeaApi, data);

    yield put({ type: IDEA_SUBMIT_SUCCESS, payload: response });
    yield put(
      showAlert({
        title: i18n.t("idea-creation-success-popup-title"),
        message: "",
      }),
    );
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_SUBMIT_ERROR, error });
  }
}

function* modifyUserIdeaFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(modifyUserIdeaApi, data);

    yield put({ type: IDEA_USER_MODIFY_SUCCESS, payload: response });
    yield put(
      showAlert({
        title: i18n.t("modify-idea-success-title"),
        message: "",
      }),
    );
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_USER_MODIFY_ERROR, error });
  }
}

function* modifyIdeaStatusFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(promoteIdeaApi, data);

    yield put({ type: IDEA_CHANGE_STATUS_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_CHANGE_STATUS_ERROR, error });
  }
}

function* getIdeasSelectionFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(getIdeasSelectionApi, data);

    yield put({ type: IDEA_GET_SELECTION_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_GET_SELECTION_ERROR });
  }
}

function* rateIdeaFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(rateIdeaApi, data);

    if (data.firstTime) {
      yield put(modifyUser({ ideaVoteHistorical: [data.ideaId] }));
    }
    yield put({ type: IDEA_RATE_SUCCESS, payload: { ideaId: data.ideaId } });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_RATE_ERROR });
  }
}

function* getAllIdeasFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(getAllIdeasApi, data);

    yield put({ type: IDEA_GET_ALL_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_GET_ALL_ERROR });
  }
}

function* loadAllIdeaFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(getAllIdeasApi, data);

    yield put({ type: IDEA_LOAD_ALL_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_LOAD_ALL_ERROR });
  }
}

function* postCommentFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(postCommentApi, data);

    yield put({ type: IDEA_POST_COMMENT_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_POST_COMMENT_ERROR, payload: error.message });
  }
}

function* getIdeaFlow(action) {
  try {
    const data = action.payload;

    const response = yield call(getIdeaApi, data);

    yield put({ type: IDEA_SEE_SELECT, payload: response });
    // NavigatorService.navigate("SeeIdea");
  } catch (error) {
    console.log(error);
    yield put({ type: IDEA_GET_ERROR, payload: error.message });
  }
}

function* sagaWatcher() {
  yield all([
    takeLatest(IDEA_SUBMIT_REQUESTING, submitIdeaFlow),
    takeLatest(IDEA_GET_SELECTION_REQUESTING, getIdeasSelectionFlow),
    takeLatest(IDEA_USER_GET_REQUESTING, getUserIdeasFlow),
    takeLatest(IDEA_USER_DELETE_REQUESTING, deleteUserIdeaFlow),
    takeLatest(IDEA_USER_MODIFY_REQUESTING, modifyUserIdeaFlow),
    takeLatest(IDEA_RATE_REQUESTING, rateIdeaFlow),
    takeLatest(IDEA_GET_ALL_REQUESTING, getAllIdeasFlow),
    takeLatest(IDEA_LOAD_ALL_REQUESTING, loadAllIdeaFlow),
    takeLatest(IDEA_CHANGE_STATUS_REQUESTING, modifyIdeaStatusFlow),
    takeLatest(IDEA_POST_COMMENT_REQUESTING, postCommentFlow),
    takeLatest(IDEA_UPLOAD_PICTURE_REQUESTING, uploadIdeaPictureFlow),
    takeLatest(
      IDEA_SELECTED_UPLOAD_PICTURE_REQUESTING,
      uploadSelectedIdeaPictureFlow,
    ),
    takeLatest(IDEA_GET_REQUESTING, getIdeaFlow),
  ]);
}

export default sagaWatcher;
